import PropTypes from 'prop-types'

import ChatForm from '../../Forms/ChatForm'
import PostTradeForm from '../../Forms/PostTradeForm'

import { EDIT } from '../../../constants/chatForms'
import { MEMBERS, TRADES } from '../../../constants/chatRooms'
import Modal from '../../Utilities/Modal'

const EditModal = ({ open, setOpen, message, channel, dispatch }) => {
  const title = channel === TRADES ? 'Edit Trade' : 'Edit Message'

  return (
    <Modal
      title={title}
      open={open}
      setOpen={setOpen}
      size={`${channel === MEMBERS ? 'md' : null}`}
      cancelText="Cancel"
    >
      {channel === TRADES ? (
        <PostTradeForm
          edit
          closeModal={setOpen}
          prefill={message}
          dispatch={dispatch}
        />
      ) : (
        <div className="flex flex-col justify-start gap-1">
          <ChatForm
            channel={channel}
            type={EDIT}
            id={message._id}
            extra={{
              toEveryone: message.toEveryone ?? false,
              highlighted: message.highlighted ?? false
            }}
            prefill={message.message}
            handleCancel={() => setOpen(false)}
            toUser={message?.toUser?._id}
            dispatch={dispatch}
          />
          <label className="text-xs italic text-gray-500">
            Press Enter to save changes to this message.
          </label>
        </div>
      )}
    </Modal>
  )
}

EditModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  message: PropTypes.object.isRequired,
  channel: PropTypes.string.isRequired
}

export default EditModal
